export type ViewMode = 'carousel' | 'slider';

export const MAX_IMAGE_HEIGHT = 640;
export const SLIDER_THUMBNAIL_HEIGHT = 67;
export const SLIDER_THUMBNAIL_WIDTH = 100;
export const SLIDER_THUMBNAIL_SIDE_PADDING = 10;
export const SLIDER_THUMBNAIL_MAX_ITEMS_VISIBLE = 6;
export const IMAGE_PIXEL_DENSITY = 2;
